export default "__VITE_ASSET__CE3xXI3L__"